import { render, staticRenderFns } from "./SingleOrg.vue?vue&type=template&id=900b7670&scoped=true&"
import script from "./SingleOrg.vue?vue&type=script&lang=js&"
export * from "./SingleOrg.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrg.vue?vue&type=style&index=0&id=900b7670&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900b7670",
  null
  
)

export default component.exports